import { render, staticRenderFns } from "./tabRender.vue?vue&type=template&id=562e3cfd"
import script from "./tabRender.vue?vue&type=script&lang=js"
export * from "./tabRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports